<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-06 17:33:28
 * @LastEditors: zcy
 * @LastEditTime: 2022-04-19 11:24:06
-->

<template>
  <!-- 路由进行新窗口跳转 -->
  <div class="route-target">
    <router-link
      @click.native="aClick"
      v-show="permission"
      tag="a"
      :target="target"
      :to="toParams"
    >
      <!-- 内容盒子 -->
      <slot></slot>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "route-target",
  props: {
    title: String,
    pathName: String,
    target: {
      type: String,
      default: () => {
        return "_blank";
      },
    },
    yearNeed: {
      type: String,
      default: "",
    },
  },
  components: {},
  data() {
    return {
      permission: true, // 是否有路由权限
    };
  },
  computed: {
    toParams() {
      if (this.yearNeed) {
        return {
          name: this.pathName,
          query: {
            year: this.yearNeed,
          },
        };
      }
      return { name: this.pathName };
    },
  },
  methods: {
    aClick(e) {
      const recordRouteArr = [
        "ym",
        "yc",
        "day-ym",
        "day-yc",
        "month-ym",
        "month-yc",
      ];
      if (recordRouteArr.includes(this.$route.name)) {
        localStorage.setItem("oldRouter", this.$route.name);
      }
    },
  },
  beforeMount() {
    // 模板编译/挂载之前
  },
  mounted() {
    // 模板编译/挂载之后
  },
  created() {
    // 判断该用户是否拥有该路由权限
  },
  beforeUpdate() {
    // 组件更新之前
  },
  updated() {
    // 组件更新之后
  },
  beforeDestroy() {
    // 组件销毁前调用
    // Tips：你确认删除XX吗？
  },
  destroyed() {
    // 组件销毁后调用
    // Tips：当前组件已被删除，清空相关内容
  },
  // 数据监听
  watch: {
    // keyName: {
    // 注意：当观察的数据为对象或数组时，curVal和oldVal是相等的，因为这两个形参指向的是同一个数据对象
    // deep: true,
    //handler (curVal, oldVal) {
    // console.log(curVal, oldVal)
    //}
    // }
  },
};
</script>

<style lang="less" scoped>
.route-target {
}
</style>